interface IProps {
    handleOnClick?: () => void
}

export const HamburgerMenu = ({ handleOnClick }: IProps) => {
    return (
        <svg onClick={handleOnClick} xmlns="http://www.w3.org/2000/svg" width="25" height="17" viewBox="0 0 25 17" fill="none">
            <path d="M24.2188 6.33653H0.78125C0.351562 6.33653 0 6.69296 0 7.1286V8.71273C0 9.14837 0.351562 9.5048 0.78125 9.5048H24.2188C24.6484 9.5048 25 9.14837 25 8.71273V7.1286C25 6.69296 24.6484 6.33653 24.2188 6.33653ZM24.2188 0H0.78125C0.351562 0 0 0.35643 0 0.792067V2.3762C0 2.81184 0.351562 3.16827 0.78125 3.16827H24.2188C24.6484 3.16827 25 2.81184 25 2.3762V0.792067C25 0.35643 24.6484 0 24.2188 0Z" fill="white" />
            <path d="M24.2188 13.1801H0.78125C0.351562 13.1801 0 13.5365 0 13.9721V15.5563C0 15.9919 0.351562 16.3483 0.78125 16.3483H24.2188C24.6484 16.3483 25 15.9919 25 15.5563V13.9721C25 13.5365 24.6484 13.1801 24.2188 13.1801Z" fill="white" />
        </svg>
    )
}